import { gql } from '@apollo/client';

export const GET_STRUCTURED_MAPPINGS = gql`
  query getStructuredMappings($version: ID!, $sourceFramework: ID!, $destinationFramework: ID) {
    getStructuredMappings(version: $version, sourceFramework: $sourceFramework, destinationFramework: $destinationFramework)
  }
`;
